import { AdvertCodes } from './constants/advertCodes'

// API 请求类型
export const API_KIND = {
  IMAGE: 'IMAGE',    // 图片类广告位（如banner、分类导航等）
  PRODUCT: 'PRODUCT' // 商品类广告位（如新品推荐等）
}

// 分页默认参数
export const PAGE_DEFAULTS = {
  PageIndex: 1,
  PageSize: 4,
  CheckTime: ''
}

// 广告位配置
export const ADVERT_CONFIG = {
  // Banner广告位
  [AdvertCodes.BANNER]: {
    Kind: API_KIND.IMAGE,
    PageSize: 4
  },
  
  // 分类导航广告位
  [AdvertCodes.CATEGORY]: {
    Kind: API_KIND.IMAGE,
    PageSize: 10
  },
  
  // 新品推荐广告位
  [AdvertCodes.NEWPRODUCT]: {
    Kind: API_KIND.PRODUCT,
    PageSize: 4
  }
}

// 获取广告位默认参数
export function getAdvertDefaultParams(advertCode) {
  const config = ADVERT_CONFIG[advertCode] || {}
  return {
    ...PAGE_DEFAULTS,
    ...config,
    AdvertCode: advertCode
  }
}